import { KeysLayout } from '@/components/layout/keys/keys'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/keys/')({
  component: ApiKeysPage,
  head: () => ({
    meta: [
      { name: 'SUL AI', content: 'SUL AI' },
      { title: 'SUL AI | API Keys' },
    ],
  }),
})

function ApiKeysPage() {
  return <KeysLayout />
}
